import { fileMobileApi } from './index';
// file/

/* [ 파일 ] */
// 파일 업로드
function upload(params) {
  return fileMobileApi.post('upload', params);
}

// 파일 목록 조회
function getFileList(fileIds) {
  return fileMobileApi.get(`list?fileIds=${fileIds}`);
}

// 파일 다운로드
function downloadFile(param) {
  return fileMobileApi.get(
    `download?fileId=${param.fileId}&fileName=${param.fileName}&seqNo=${param.seqNo}`,
  );
}

// 파일삭제
function deleteFile(params) {
  return fileMobileApi.post(`delete`, params);
}

export { upload, getFileList, downloadFile, deleteFile };
